/**
 * Legacy PermissionsService module — preserved as an empty AngularJS module so
 * existing dependencies (`acme.common.service.permissions`) keep resolving.
 *
 * The actual `PermissionsService` factory is now registered in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts as a downgrade
 * of the unified Angular 18 PermissionsService at
 * apps/b2b-frontend/app/core/permissions/permissions.service.ts.
 *
 * Do NOT register `.service('PermissionsService', ...)` here — it would
 * shadow the downgraded service and reintroduce the legacy implementation.
 */
angular.module('acme.common.service.permissions', [
  'angular-md5',
  'acme.common.service.config',
  'acme.common.service.storage',
]);
